import { render, staticRenderFns } from "./BeneficiaryOffers.vue?vue&type=template&id=b09081c2&"
import script from "./BeneficiaryOffers.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryOffers.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryOffers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports